import React from "react";
import ReportsView from "./ReportsView";

export function ReportsContainer() {
  return <ReportsView title="Reports" />;
}
